import {loadScript, forEach} from "../../js/helpers";

(() => {
  const mapEl = document.getElementById('deliveryMap');
  const selectEl = document.querySelector('.deliverySelect');

  if (mapEl) {
    loadScript("https://api-maps.yandex.ru/2.1/?apikey=109e4b66-0503-4da1-b84c-bc91501ea5fa&lang=ru_RU", map)
  }

  const mapData = {
    colors: ["#D52A3F", "#76C2B1", "#FFBF3F"]
  };

  function map() {
    if (ymaps) {
      ymaps.ready(init);

      function init() {
        const myMap = new ymaps.Map("deliveryMap", {
          center: [Number(mapEl.dataset.lat), Number(mapEl.dataset.lng)],
          controls: ['zoomControl', 'geolocationControl'],
          zoom: 14
        }, {
          zoomControlSize: 'small',
          zoomControlPosition: {
            right: "20px",
          },
          geolocationControlPosition: {
            right: "20px",
            top: "70px"
          },
        });

        myMap.behaviors.disable('scrollZoom');

        const allCollections = [];

        forEach(selectEl.children, option => {
          const areasCollection = new ymaps.GeoObjectCollection(null);
          console.log(JSON.parse(option.dataset.areas));
          forEach(JSON.parse(option.dataset.areas), (area, index) => {
            // console.log(area.coords);
            // console.log(area.title);
            const myGeoObject = new ymaps.GeoObject({
              geometry: {
                type: "Polygon",
                coordinates: [area.coords],
                fillRule: "nonZero"
              },
              properties:{
                balloonContent: area.title
              }
            }, {
              fillColor: mapData.colors[index],
              strokeWidth: 0,
              opacity: 0.2
            });
            areasCollection.add(myGeoObject);
          });
          allCollections.push(areasCollection);
          myMap.geoObjects.add(areasCollection);
          console.log(1);
        });
        console.log(2);
        console.log(myMap);
        console.log(allCollections);

        myMap.setBounds(allCollections[0].getBounds());

        selectEl.addEventListener('change', () => {
          // console.log(selectEl.selectedIndex);
          // console.log(myMap.geoObjects.get(selectEl.selectedIndex));
          // console.log(myMap.geoObjects.get(selectEl.selectedIndex).geometry._bounds);
          myMap.setBounds(allCollections[selectEl.selectedIndex].getBounds());
          // myMap.setBounds(myCollection.getBounds());
          window.scroll(0, mapEl.offsetTop);

        });
      }
    }
  }

})();

